import { render, staticRenderFns } from "./deviceAnswerCount.vue?vue&type=template&id=bd1f8352&scoped=true&"
import script from "./deviceAnswerCount.vue?vue&type=script&lang=js&"
export * from "./deviceAnswerCount.vue?vue&type=script&lang=js&"
import style0 from "./deviceAnswerCount.vue?vue&type=style&index=0&id=bd1f8352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1f8352",
  null
  
)

export default component.exports